import { RootState } from "@app/redux/root-reducer";

export const selectMyOrders = (store: RootState) =>
  store.myOrdersReducer.myOrders;
